module.exports = __webpack_public_path__ + "static/SFCompactLight-c8fe92bdc27b20a8aa752b190515b30d.woff2";